import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ArticleContinuedPanelComponent } from './article-continued-panel.component';
import { SharedModule } from 'src/app/shared/shared.module';

/**
 * @deprecated
 */
@NgModule({
  declarations: [ArticleContinuedPanelComponent],
  exports: [ArticleContinuedPanelComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
})
export class ArticleContinuedPanelModule { }
